import { ValidateRequest, ValidateResponse } from './data-contracts';
import { ContentType, HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class TotalValidate<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * No description
	 *
	 * @tags TotalValidate
	 * @name TotalValidate
	 * @request POST:/store/{storeId}/hdm/shopcart/totalValidate
	 * @response `200` `ValidateResponse` Successful validation
	 */
	totalValidate = (
		storeId: string,
		query: {
			/** @example "json" */
			responseFormat: string;
			/** @example "-5" */
			langId: string;
		},
		data: ValidateRequest,
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['totalValidate'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/hdm/shopcart/totalValidate`,
				params: _params,
				query: query,
				body: data,
				methodName: 'totalValidate',
			};
			logger.trace(traceData);
		}
		return this.http.request<ValidateResponse, any>({
			path: `/store/${storeId}/hdm/shopcart/totalValidate`,
			method: 'POST',
			query: query,
			body: data,
			type: params.type ?? ContentType.Json,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
